import {
  Box,
  Button,
  Modal,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { Dispatch, SetStateAction } from "react";
import { COMMON_LABELS } from "../default-constants";
import {
  BankAccountsReferenceResponse,
  BankAccountsUpdateRequest,
} from "../../features/api-interfaces";
import { IErrMsg, LABELS } from "./constants";
import { BankAccount } from "./BankAccount";
import { ReferenceGroup } from "./ReferenceGroup";
import { PaymentCycle } from "./PaymentCycle";
import { PaymentTargetCompany } from "./PaymentTargetCompany";

interface IBankAccountsHelpPanel {
  isFetching: boolean;
  apiResponse?: BankAccountsReferenceResponse;
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  request: BankAccountsUpdateRequest;
  setRequest: Dispatch<SetStateAction<BankAccountsUpdateRequest>>;
  errMsg: IErrMsg;
  setErrMsg: Dispatch<SetStateAction<IErrMsg>>;
}

export const UpdatingContentModal = (props: IBankAccountsHelpPanel) => {
  const {
    isFetching,
    apiResponse,
    isModalOpen,
    setIsModalOpen,
    request,
    setRequest,
    errMsg,
    setErrMsg,
  } = props;

  /**
   * モーダルを閉じる.
   */
  const onClose = () => setIsModalOpen(false);

  return (
    <Modal
      onDismiss={onClose}
      visible={isModalOpen}
      size={"large"}
      header={LABELS.UPDATING_CONTENT_TITLE}
      footer={
        <Box float={"left"}>
          <Button formAction={"none"} variant={"link"} onClick={onClose}>
            {COMMON_LABELS.BTNS.CLOSE}
          </Button>
        </Box>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        <ReferenceGroup
          referenceGroup={apiResponse?.prodInfo.referenceGroup}
          isModalOpen={isModalOpen}
          isUpdate={false}
          request={request}
          setRequest={setRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
        <BankAccount
          bankAccount={apiResponse?.wkInfo.bankAccount}
          isModalOpen={isModalOpen}
          isUpdate={false}
          request={request}
          setRequest={setRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
        <PaymentCycle
          paymentCycleCode={apiResponse?.wkInfo.paymentCycleCode}
          isModalOpen={isModalOpen}
          isUpdate={false}
          request={request}
          setRequest={setRequest}
        />
        <PaymentTargetCompany
          isFetching={isFetching}
          paymentTargetCompany={apiResponse?.wkInfo.paymentTargetCompany}
          isModalOpen={isModalOpen}
          isUpdate={false}
          request={request}
          setRequest={setRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
      </SpaceBetween>
    </Modal>
  );
};
